import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/settings/organisations/$organisationId/settings",
      params,
      replace: true,
    });
  },
});
